(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/dialogs.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/dialogs.js');

'use strict';

const formatCurrency = svs.utils.format.Currency;
const showActivationDialog = (memberName, syndicateName) => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'help',
    title: "<span class=\"data-hj-suppress\">".concat(memberName, "</span> vill bli aktiverad i ").concat(syndicateName, "."),
    actions: [{
      title: 'Ignorera',
      callback: () => {
        dialog.close();
        resolve(false);
      }
    }, {
      title: 'Aktivera',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showErrorMessageDialog = (title, message, callback) => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: title || 'Fel vid skapandet av lag',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: message ? message : 'Vänligen kontakta Kundservice om problemet kvarstår'
    }],
    actions: [{
      title: 'Okej',
      callback
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showSuccessDialog = (title, text) => {
  let dialog = {};
  const options = {
    icon: 'thumbs-up',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    title,
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  };
  if (text) {
    options.message = [{
      type: svs.ui.dialog.message.TEXT,
      text
    }];
  }
  dialog = new svs.ui.dialog.Confirm(options);
  svs.ui.dialog.api.add(dialog);
};
const showTeamIsCreatedDialog = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'thumbs-up',
    title: 'Laget är skapat',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Du hittar ditt lag under <strong>Alla lag</strong>.'
    }],
    actions: [{
      type: svs.ui.dialog.button.PRIMARY,
      title: 'Okej',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showPromiseDialog = _ref => {
  let {
    icon = 'thumbs-up',
    title,
    text,
    buttonText = 'Okej'
  } = _ref;
  return new Promise(resolve => {
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      icon,
      title,
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text
      }],
      actions: [{
        title: 'Avbryt',
        callback: () => {
          dialog.close();
          resolve(false);
        }
      }, {
        type: svs.ui.dialog.button.PRIMARY,
        title: buttonText,
        callback: () => {
          dialog.close();
          resolve(true);
        }
      }]
    });
    svs.ui.dialog.api.add(dialog);
  });
};
function showCreateTechnicalFailureDialog(errortype) {
  const messages = [{
    type: 'syndicate',
    text: 'Ett fel uppstod i skapandet av ditt lag.'
  }, {
    type: 'invites',
    text: "Ett fel uppstod i skapandet av ditt lag. <p>Inbjudningar kunde inte skickas.</p>"
  }, {
    type: 'syndicateBalance',
    text: 'Ett fel uppstod i skapandet av ditt lag. <p>Pengarna kunde inte överföras till lagkassan.</p><p>Inbjudningar kunde inte skickas.</p>'
  }];
  const messageData = messages.find(mess => mess.type === errortype);
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Tekniskt fel',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: (messageData === null || messageData === void 0 ? void 0 : messageData.text) || ''
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
}
const showSuspensionMessageDialog = suspensions => {
  const activeSuspension = suspensions.filter(suspension => suspension.product === 'all');
  activeSuspension.forEach(suspension => {
    suspension.duration = Math.round(dateFns.differenceInMonths(dateFns.parseISO(suspension.validTo || suspension.terminable), dateFns.parseISO(suspension.validFrom)));
  });
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'spelpaus',
    title: 'Spelpaus',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: svs.accountservices.suspension_message.templates.message({
        suspensions: activeSuspension
      })
    }],
    actions: [{
      title: 'Okej'
    }]
  }));
};
const showPlayableAmountInformationDialog = attachedTo => {
  const dialog = new svs.ui.dialog.Contextual({
    branding: svs.ui.dialog.branding.TUR,
    attachTo: attachedTo,
    title: 'Spelbart saldo i laget',
    message: [{
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: 'När ni köper ett spel bidrar alla medlemmar med lika mycket, vilket betyder att lägsta saldot bestämmer hur mycket ni kan spela för.'
    }, {
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: 'Exempel: I ett lag med 4 medlemmar där medlemmen med lägst saldo i laget har <strong>10</strong> kr kan laget spela för <strong>40</strong> kr.<br/> 4 * 10 kr = 40 kr'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showAllAdminInformationDialog = attachedTo => {
  const dialog = new svs.ui.dialog.Contextual({
    branding: svs.ui.dialog.branding.TUR,
    attachTo: attachedTo,
    title: '',
    message: [{
      align: svs.ui.dialog.message.align.CENTER,
      type: svs.ui.dialog.message.TEXT,
      text: 'Du kan välja att bara lagledaren och eventuella spelläggare i laget skall kunna lägga och annullera spel. I medlemslistan kan du ändra roller i laget.'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showConfirmDeactivateDialog = function () {
  let firstName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medlemmen';
  let memberBalance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0,00';
  return new Promise(resolve => {
    const text = memberBalance === '0,00' ? '' : "<span class=\"data-hj-suppress\">".concat(firstName, "</span> kommer att f\xE5 sin del av lagsaldo \xF6verf\xF6rt till sitt spelkonto.");
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      icon: 'rest',
      title: "Vill du g\xF6ra <span class=\"data-hj-suppress\">".concat(firstName, "</span> vilande i laget?"),
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text
      }],
      actions: [{
        title: 'Avbryt',
        callback: () => {
          dialog.close();
          resolve(false);
        }
      }, {
        title: 'Gör vilande',
        callback: () => {
          dialog.close();
          resolve(true);
        }
      }]
    });
    svs.ui.dialog.api.add(dialog);
  });
};
const showConfirmEmailDialog = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'e-post',
    title: 'För att skapa ett lag behöver du ha en verifierad e-postadress',
    actions: [{
      title: 'Avbryt',
      callback: () => {
        dialog.close();
        resolve(false);
      }
    }, {
      title: 'Skicka ny länk',
      callback: () => {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showCopyInviteLinkSuccessToaster = () => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'copy',
    area: svs.ui.dialog.area.TOASTER,
    autoClose: svs.ui.dialog.autoClose.SHORT,
    title: 'Länk kopierad'
  });
  svs.ui.dialog.api.add(dialog);
};
const showCopyInviteLinkFailToaster = () => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'help-2',
    area: svs.ui.dialog.area.TOASTER,
    autoClose: svs.ui.dialog.autoClose.SHORT,
    title: 'Det gick inte att kopiera länken'
  });
  svs.ui.dialog.api.add(dialog);
};
const showShareFailedToaster = () => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'help-2',
    area: svs.ui.dialog.area.TOASTER,
    autoClose: svs.ui.dialog.autoClose.SHORT,
    title: 'Länken delades inte'
  });
  svs.ui.dialog.api.add(dialog);
};

const showActivationRequestSent = teamLeader => showSuccessDialog("En aktiveringsf\xF6rfr\xE5gan har skickats till ".concat(teamLeader));
const showActivationRequestError = teamName => showErrorMessageDialog("Kunde inte skicka f\xF6rfr\xE5gan om aktivering i ".concat(teamName));
const showDeleteTeamSuccess = team => showSuccessDialog("Laget ".concat(team ? "".concat(team, " ") : '', "\xE4r avslutat "));
const showDeleteTeamSuccessAlt = (team, amount) => showSuccessDialog("Du har avslutat ".concat(team ? team : 'laget'), amount ? "".concat(formatCurrency(amount), " kr har \xF6verf\xF6rts till ditt spelkonto. Observera att det kan ta en stund innan ditt saldo uppdateras.") : null);
const showJoinTeamSuccess = (team, amount) => showSuccessDialog("Du \xE4r nu medlem i laget ".concat(team), " Du har f\xF6rt \xF6ver ".concat(amount, " kr fr\xE5n ditt spelkonto till lagkontot."));
const showLeaveTeamSuccess = (team, amount) => showSuccessDialog("Du har l\xE4mnat ".concat(team ? team : 'laget'), parseInt(amount, 10) > 0 ? "".concat(parseInt(amount, 10), " kr har \xF6verf\xF6rts till ditt spelkonto. Observera att det kan ta en stund innan ditt saldo uppdateras.") : null);
const showSendReminderSuccess = email => showSuccessDialog("En p\xE5minnelse har skickats till ".concat(email));
const showSendReminderNameSuccess = function () {
  let firstName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medlemmen';
  let lastName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return showSuccessDialog("En p\xE5minnelse har skickats till <span class=\"data-hj-suppress\">".concat(firstName, " ").concat(lastName, "</span>"));
};
const showSendMessageSuccess = function () {
  let firstName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medlemmen';
  let lastName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return showSuccessDialog("Meddelandet har skickats till <span class=\"data-hj-suppress\">".concat(firstName, " ").concat(lastName, "</span>"));
};
const showSendMessageAllSuccess = () => showSuccessDialog("Meddelandet har skickats till alla medlemmar i laget");
const showSendMessageError = () => showErrorMessageDialog('Meddelande kan inte skickas', 'Vänligen kontakta Kundservice om problemet kvarstår');

const showActivateMemberSuccess = function () {
  let firstName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Medlemmen';
  let lastName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return showSuccessDialog("<span class=\"data-hj-suppress\">".concat(firstName, " ").concat(lastName, "</span> har aktiverats"));
};
const showDeactivateMemberSuccess = function () {
  let firstName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Medlemmen';
  let lastName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return showSuccessDialog("<span class=\"data-hj-suppress\">".concat(firstName, " ").concat(lastName, "</span> \xE4r nu vilande"), 'Vilande medlemmar behöver aktiveras igen för att kunna delta i lagspel.');
};
const showTechnicalError = callback => showErrorMessageDialog('Tekniskt fel', 'Försök igen senare.', callback);
const showTechnicalErrorGettingTeams = () => showErrorMessageDialog('Tekniskt fel', 'Vi kunde inte hämta ditt nya lag. Försök igen senare.');
const showRemoveInviteError = () => showErrorMessageDialog('Kunde inte ta bort inbjudan');
const showInviteeReminderError = () => showErrorMessageDialog('Kunde inte skicka påminnelse');
const showRemoveMemberQuestionDialog = function (amount) {
  let teamName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'laget';
  let firstName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'medlemmen';
  let lastName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return showPromiseDialog({
    icon: 'help',
    title: "Vill du ta bort <span class=\"data-hj-suppress\">".concat(firstName, " ").concat(lastName, "</span> fr\xE5n ").concat(teamName, "?"),
    buttonText: 'Ta bort medlem',
    text: amount ? "<span class=\"data-hj-suppress\">".concat(firstName, "</span> kommer att f\xE5 ").concat(formatCurrency(amount), " kr \xF6verf\xF6rt fr\xE5n lagkontot till sitt spelkonto") : ''
  });
};
const showLeaveTeamQuestionDialog = function () {
  let teamName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'laget';
  let amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0,00';
  return showPromiseDialog({
    icon: 'help',
    title: "Vill du l\xE4mna ".concat(teamName, "?"),
    buttonText: 'lämna laget',
    text: "".concat(parseInt(amount, 10) > 0 ? "Du kommer att f\xE5 ".concat(formatCurrency(amount), " \xF6verf\xF6rt till ditt spelkonto. ") : '', "Eventuella vinster i p\xE5g\xE5ende spel kommer att f\xF6ras \xF6ver till ditt spelkonto.")
  });
};
const showDeleteTeamQuestionDialog = function () {
  let teamName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'laget';
  return showPromiseDialog({
    icon: 'help',
    title: "\xC4r du s\xE4ker p\xE5 att du vill avsluta ".concat(teamName, "?"),
    buttonText: 'Avsluta laget',
    text: 'Andelar i laget och eventuella vinster i pågående spel kommer att föras över till medlemmarnas spelkonton.'
  });
};
const showRemoveMemberError = function () {
  let firstName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medlemmen';
  return showErrorMessageDialog("Kunde inte ta bort <span class=\"data-hj-suppress\">".concat(firstName, "</span>"));
};
const showLeaveTeamError = () => showErrorMessageDialog("Kunde inte ta bort medlem fr\xE5n laget");
const showInviteMembersSuccess = isMultiple => showSuccessDialog("Inbjudning".concat(isMultiple ? 'ar' : '', " har skickats "));
const showAddedAdminSuccess = function () {
  let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medlemmen';
  return showSuccessDialog("<span class=\"data-hj-suppress\">".concat(name, "</span> \xE4r nu spell\xE4ggare"), 'Om du klickar ur valet "Alla medlemmar kan lägga spel" kommer bara du själv och spelläggare kunna lägga och annullera spel.');
};
const showRemovedAdminSucess = function () {
  let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medlemmen';
  return showSuccessDialog("<span class=\"data-hj-suppress\">".concat(name, "</span> \xE4r inte l\xE4ngre spell\xE4ggare"));
};
const showCreateNewInviteLinkSuccess = validUntil => {
  let text = 'Den nya länken går nu att använda.';
  if (validUntil) {
    text = "Den nya l\xE4nken \xE4r giltig fram till och med den ".concat(svs.utils.date.FormatTime('d MMM', validUntil), ".");
  }
  showSuccessDialog('Ny inbjudningslänk skapad', text);
};
svs.arena.pages.teams.dialogs = {
  showTechnicalError,
  showTechnicalErrorGettingTeams,
  showActivationRequestSent,
  showActivationDialog,
  showTeamIsCreatedDialog,
  showCreateTechnicalFailureDialog,
  showErrorMessageDialog,
  showSuspensionMessageDialog,
  showPlayableAmountInformationDialog,
  showDeleteTeamSuccess,
  showJoinTeamSuccess,
  showLeaveTeamSuccess,
  showDeleteTeamSuccessAlt,
  showSendReminderSuccess,
  showSendMessageSuccess,
  showSendMessageAllSuccess,
  showActivateMemberSuccess,
  showDeactivateMemberSuccess,
  showConfirmDeactivateDialog,
  showSendMessageError,
  showRemoveInviteError,
  showInviteeReminderError,
  showSendReminderNameSuccess,
  showActivationRequestError,
  showRemoveMemberQuestionDialog,
  showRemoveMemberError,
  showLeaveTeamError,
  showLeaveTeamQuestionDialog,
  showInviteMembersSuccess,
  showDeleteTeamQuestionDialog,
  showConfirmEmailDialog,
  showCopyInviteLinkSuccessToaster,
  showCopyInviteLinkFailToaster,
  showShareFailedToaster,
  showCreateNewInviteLinkSuccess,
  showAllAdminInformationDialog,
  showAddedAdminSuccess,
  showRemovedAdminSucess
};

 })(window);